<template>
 
    <div class="text-center ">
     <form class="form-signin" @submit.prevent>
       <h1 class="h3 mb-3 font-weight-normal">Ustawienia</h1>
  
        <input class="form-control" v-model.trim="name" type="text" :placeholder="userProfile.name" id="name" />


        <input class="form-control mt-1" v-model.trim="title" type="text" :placeholder="userProfile.title" id="title" />
         <input class="form-control mt-1" v-model.trim="companyEmail" type="text" :placeholder="userProfile.companyEmail" />
          <input class="form-control mt-1" v-model.trim="phoneOne" type="text" :placeholder="userProfile.phoneOne" id="title" />
           <input class="form-control mt-1" v-model.trim="phoneTwo" type="text" :placeholder="userProfile.phoneTwo" id="title" />
            <input class="form-control mt-1" v-model.trim="companyAddress" type="text" :placeholder="userProfile.companyAddress" id="title" />

        <button @click="updateProfile()" class="btn btn-success mt-1">Uaktualnij profil</button>
      </form>
      
      <div v-if="showSuccess" class="alert alert-success" role="alert">
        <p  class="success">Profil zaktualizowany</p>
      </div>
    </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      name: '',
      title: '',
      companyEmail:'',
      companyAddress:'',
      phoneOne: '',
      phoneTwo: '',
      showSuccess: false
    }
  },
  computed: {
    ...mapState(['userProfile'])
  },
  methods: {
    updateProfile() {
      this.$store.dispatch('updateProfile', {
        name: this.name !== '' ? this.name : this.userProfile.name,
        title: this.title !== '' ? this.title : this.userProfile.title,
        companyEmail: this.companyEmail !== '' ? this.companyEmail : this.userProfile.companyEmail,
        phoneOne: this.phoneOne !== '' ? this.phoneOne : this.userProfile.phoneOne,
        phoneTwo: this.phoneTwo !== '' ? this.phoneTwo : this.userProfile.phoneTwo,
        companyAddress: this.companyAddress !== '' ? this.companyAddress : this.userProfile.companyAddress,
        
       })

      this.name = ''
      this.title = ''

      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 2000)
    }
  }
}
</script>
<style scoped>

.form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}
</style>
